import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";
import Video from "@/views/Video.vue";
import SplashScreen from "@/views/Splashscreen.vue";
import Stickers from "@/views/Stickers.vue";
import Users from "@/views/Users.vue";
import Coupon from "@/views/Coupon.vue";
import CardReader from "@/views/CardReader.vue";
import NotFound from "@/views/NotFound.vue";
import {SalesStatisticsPage} from "@/views/sales-statistics-page";

export default [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/video',
    name: 'Video',
    component: Video,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/splashscreen',
    name: 'SplashScreen',
    component: SplashScreen,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/stickers',
    name: 'Stickers',
    component: Stickers,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: SalesStatisticsPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/coupon',
    name: 'Coupon',
    component: Coupon,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/card',
    name: 'CardReader',
    component: CardReader,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '*',
    redirect: '404'
  }
]